import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import timeAccounts from "./server/timeAccounts";
import setup from "./server/setup";

export default {
  namespaced: true,
  state: {
    time: "",
    settings: "",
    logo: "",
    allowUserCloseOpenBooking: 1,
    automaticCloseOpenBooking: 0,
    stageProjectsAllowed: 1,
    serviceCallsAllowed: 1,
    financeProjectsAllowed: 1,
    stageProjectsWithoutPermissions: 0,
    showFinanceProjectByProjectManagement: 0,
    serviceCallsWithoutPermissions: 0,
    showAbesenceApprovalsOnPresencelist: 0,
    allowProjectText: 0,
    showNewTimeCorrection: 0,
    hideCommentByTimeCorrection: 0,
    showCostCentre: 0,
    language: "de",
    processing: false,
    absences: [],
    absenceForSickKPI: null,
    timestamp: null,
    minutePassed: true,
    defaultState: null,
    showBusinessTripByTimeKeeping: 0,
    showBusinessTripByTimeKeepingOnlyIfItsApproved: 0,
    requireLocation: 0,
    automaticLocationByRFID: 0,
    sapConnection: "disconnected",
    states: [
      { value: null, name: "" },
      { value: "BW", name: "Baden-Württemberg" },
      { value: "BY", name: "Bayern" },
      { value: "BE", name: "Berlin" },
      { value: "BB", name: "Brandenburg" },
      { value: "HB", name: "Bremen" },
      { value: "HH", name: "Hamburg" },
      { value: "HE", name: "Hessen" },
      { value: "MV", name: "Mecklenburg-Vorpommern" },
      { value: "NI", name: "Niedersachsen" },
      { value: "NW", name: "Nordrhein-Westfalen" },
      { value: "RP", name: "Rheinland-Pfalz" },
      { value: "SL", name: "Saarland" },
      { value: "SN", name: "Sachsen" },
      { value: "ST", name: "Sachsen-Anhalt" },
      { value: "SH", name: "Schleswig-Holstein" },
      { value: "TH", name: "Thüringen" }
    ]
  },
  mutations: {
    processServerTime(state, time) {
      state.time = time;
    },
    setSettings(state, settings) {
      state.settings = settings;
      for (let set of settings) {
        if (set.U_settingName == "Logo") state.logo = set.U_settingStringData;
        else if (set.U_settingName == "allowUserCloseOpenBooking") state.allowUserCloseOpenBooking = set.U_settingNumericData;
        else if (set.U_settingName == "automaticCloseOpenBooking") state.automaticCloseOpenBooking = set.U_settingNumericData;
        else if (set.U_settingName == "stagePrjAllowed") state.stageProjectsAllowed = set.U_settingNumericData;
        else if (set.U_settingName == "srcCallsAllowed") state.serviceCallsAllowed = set.U_settingNumericData;
        else if (set.U_settingName == "financePrjAllowed") state.financeProjectsAllowed = set.U_settingNumericData;
        else if (set.U_settingName == "stagePrjPermissions") state.stageProjectsWithoutPermissions = set.U_settingNumericData;
        else if (set.U_settingName == "srcCallsPermissions") state.serviceCallsWithoutPermissions = set.U_settingNumericData;
        else if (set.U_settingName == "showAbsApprovals") state.showAbesenceApprovalsOnPresencelist = set.U_settingNumericData;
        else if (set.U_settingName == "allowProjectText") state.allowProjectText = set.U_settingNumericData;
        else if (set.U_settingName == "showFinPrjByPrjMgt") state.showFinanceProjectByProjectManagement = set.U_settingNumericData;
        else if (set.U_settingName == "showCostCentre") state.showCostCentre = set.U_settingNumericData;
        else if (set.U_settingName == "showNewTimeCorrection") state.showNewTimeCorrection = set.U_settingNumericData;
        else if (set.U_settingName == "hidCmtByTimeCorr") state.hideCommentByTimeCorrection = set.U_settingNumericData;
        else if (set.U_settingName == "Language") state.language = set.U_settingStringData;
        else if (set.U_settingName == "defaultState") state.defaultState = set.U_settingStringData;
        else if (set.U_settingName == "showBusinessTripByTimeKeeping") state.showBusinessTripByTimeKeeping = set.U_settingNumericData;
        else if (set.U_settingName == "showBusinessTripByTimeKeepingOnlyIfItsApproved")
          state.showBusinessTripByTimeKeepingOnlyIfItsApproved = set.U_settingNumericData;
        else if (set.U_settingName == "requireLocation") state.requireLocation = set.U_settingNumericData;
        else if (set.U_settingName == "automaticLocationByRFID") state.automaticLocationByRFID = set.U_settingNumericData;
        else if (set.U_settingName == "absenceForSickKPI") state.absenceForSickKPI = set.U_settingNumericData;
      }
    },
    setLogo(state, logo) {
      state.logo = logo;
    },
    saveSetting(state, val) {
      state.processing = val;
    },
    setAbsences(state, absences) {
      state.absences = absences;
    },
    setTimestamp(state, val) {
      if (state.timestamp == null) {
        state.timestamp = val;
        state.minutePassed = true;
      } else if (val.diff(state.timestamp, "minutes") > 0) {
        state.timestamp = val;
        state.minutePassed = true;
      } else state.minutePassed = false;
    },
    setSapConnection(state, val) {
      state.sapConnection = val;
    }
  },
  actions: {
    getServerTime({ commit }) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/server/getServerTime",
            method: "GET"
          })
          .then((resp) => {
            commit("processServerTime", resp.data.currentTime);
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    setTime({ commit }, dateTime) {
      commit("processServerTime", dateTime);
    },
    getLogo({ commit }) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/server/getLogo",
            method: "GET"
          })
          .then((resp) => {
            commit("setLogo", resp.data.U_settingStringData);
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getSettings({ commit, state }, timestamp) {
      commit("setTimestamp", timestamp);
      if (state.minutePassed)
        return new Promise((resolve, reject) => {
          Vue.prototype
            .$http({
              url: Vue.prototype.apiUrl + "/api/server/settings",
              method: "GET"
            })
            .then((resp) => {
              commit("setSettings", resp.data);
              resolve(resp);
            })
            .catch((err) => {
              reject(err);
            });
        });
    },
    getCobiTimeVersion() {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/server/getCobiTimeVersion",
            method: "GET"
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    saveSettings({ commit }, settings) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/server/settings",
            data: settings,
            method: "POST"
          })
          .then((resp) => {
            commit("setSettings", settings);
            resolve(resp);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    resetLogo({ commit }, setting) {
      commit("saveSetting", true);
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/server/settings/" + setting.U_settingName,
            data: setting,
            method: "PATCH"
          })
          .then((resp) => {
            commit("saveSetting", false);
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    saveAbsences({ commit }, absences) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/server/saveAbsenceReasons",
            method: "POST",
            data: absences
          })
          .then((resp) => {
            commit("setAbsences", absences);
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getAbsenceReasons({ commit }) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/absences",
            method: "GET"
          })
          .then((resp) => {
            commit("setAbsences", resp.data);
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    checkConnection({ commit }) {
      commit("setSapConnection", "connecting");
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/server/checkConnection",
            method: "GET"
          })
          .then((resp) => {
            commit("setSapConnection", "connected");
            resolve();
          })
          .catch((err) => {
            commit("setSapConnection", "disconnected");
            reject(err);
          });
      });
    }
  },
  modules: {
    timeAccounts,
    setup
  },
  getters: {
    serverTime: (state) => state.time,
    logo: (state) => state.logo,
    language: (state) => state.language,
    factorAuth: (state) => state.settings,
    absences: (state) => state.absences,
    allowUserCloseOpenBooking: (state) => state.allowUserCloseOpenBooking,
    automaticCloseOpenBooking: (state) => state.automaticCloseOpenBooking,
    stageProjectsAllowed: (state) => state.stageProjectsAllowed,
    serviceCallsAllowed: (state) => state.serviceCallsAllowed,
    financeProjectsAllowed: (state) => state.financeProjectsAllowed,
    stageProjectsWithoutPermissions: (state) => state.stageProjectsWithoutPermissions,
    showFinanceProjectByProjectManagement: (state) => state.showFinanceProjectByProjectManagement,
    serviceCallsWithoutPermissions: (state) => state.serviceCallsWithoutPermissions,
    showAbesenceApprovalsOnPresencelist: (state) => state.showAbesenceApprovalsOnPresencelist,
    allowProjectText: (state) => state.allowProjectText,
    showCostCentre: (state) => state.showCostCentre,
    showNewTimeCorrection: (state) => state.showNewTimeCorrection,
    hideCommentByTimeCorrection: (state) => state.hideCommentByTimeCorrection,
    states: (state) => state.states,
    defaultState: (state) => state.defaultState,
    showBusinessTripByTimeKeeping: (state) => state.showBusinessTripByTimeKeeping,
    showBusinessTripByTimeKeepingOnlyIfItsApproved: (state) => state.showBusinessTripByTimeKeepingOnlyIfItsApproved,
    sapConnection: (state) => state.sapConnection,
    requireLocation: (state) => state.requireLocation,
    automaticLocationByRFID: (state) => state.automaticLocationByRFID,
    absenceForSickKPI: (state) => state.absenceForSickKPI
  }
};
